import {RQ_GET_RCPA_CATEGORY_LIST, RQ_GET_SYS_LOV_BY_TYPE} from '@app/reactQuery/apis/constants/rqCommonAPIConstant';
import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';

export const RqSystemLov = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_system_lov', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, category} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_SYS_LOV_BY_TYPE,
        null,
        certificate,
        {category},
        signal,
      );
    },
    ...options,
  });
};

export const RQGetRcpaCategoryList = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_rcpa_category_list', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_RCPA_CATEGORY_LIST,
        null,
        certificate,
        null,
        signal,
      );
    },
    ...options,
  });
};

// export const RQGetRcpaCategoryList = async ({certificate, signal}) => {
//   return rqCreateRequest(
//     RQ_GET_RCPA_CATEGORY_LIST,
//     null,
//     certificate,
//     null,
//     signal,
//   );
// };
